import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import IPriceItem from '@app/types/data/base/IPriceItem';
import IOfferESlideData from '@app/types/data/slides/IOfferESlideData';
import IOfferEPriceMatrixItem from '@app/types/data/slides/present/IOfferEPriceMatrixItem';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import { Entry } from 'contentful';

/**
 * Transform for 013-OfferESlide
 */
export default class OfferESlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'OfferESlide';

	public async transform(slide: ISlideMaster, presentationSettings: IPresentationSettings): Promise<IOfferESlideData> {
		const data: IOfferESlideData = {
			...(await super.transform(slide, presentationSettings)),
			connection: slide.fields.connection ? this.parseConnection(slide.fields.connection) : undefined,
			priceMatrix: slide.fields.prices.map(
				(priceEntry: Entry<any>): IOfferEPriceMatrixItem => ({
					svgGroupId: priceEntry.fields.svgGroupId as IOfferEPriceMatrixItem['svgGroupId'],
					dayCount: priceEntry.fields.numberOfDays as IOfferEPriceMatrixItem['dayCount'],
					individuals: {
						adult: priceEntry.fields.priceAdult as IPriceItem['adult'],
						adultHighSeason: priceEntry.fields.priceAdultHighSeason as IPriceItem['adultHighSeason'],
						senior: priceEntry.fields.priceSenior as IPriceItem['senior'],
						youth: priceEntry.fields.priceYouth as IPriceItem['youth'],
						child: priceEntry.fields.priceChild as IPriceItem['child'],
						pupil: priceEntry.fields.pricePupil as IPriceItem['pupil']
					},
					groups: {
						adult: priceEntry.fields.priceAdultInGroup as IPriceItem['adult'],
						adultHighSeason: priceEntry.fields.priceAdultHighSeasonInGroup as IPriceItem['adultHighSeason'],
						senior: priceEntry.fields.priceSeniorInGroup as IPriceItem['senior'],
						youth: priceEntry.fields.priceYouthInGroup as IPriceItem['youth'],
						child: priceEntry.fields.priceChildInGroup as IPriceItem['child'],
						pupil: priceEntry.fields.pricePupilInGroup as IPriceItem['pupil']
					}
				})
			),
			priceInfo: slide.fields.priceInfo
				? this.transformRichtext(slide.fields.priceInfo, presentationSettings)
				: undefined,
			mapImage: this.transformImageAsset(slide.fields.mapImage?.fields.asset ?? this.getFallbackImage(), {
				width: 5000,
				height: 5000,
				crop: 'limit'
			}),
			elevation: slide.fields.elevationMax,
			elevationMin: slide.fields.elevationMin,
			elevationMax: slide.fields.elevationMax
		};

		return data;
	}
}
